import { render } from "./App.vue?vue&type=template&id=09f556ec&bindings={\"scrolled\":\"data\",\"factories\":\"data\",\"state\":\"data\",\"options\":\"data\",\"anchors\":\"data\",\"activateButton\":\"options\",\"next\":\"options\",\"previous\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script